<template>
  <div id="detailDiv" class="content-detail">
    <Tabs type="card" @on-click="changeTab" v-model="tabName">
        <TabPane label="汇总描述" icon="ios-apps" name="hzms">
          <div v-show="tabName === 'hzms'">
            <Row :gutter="20" shadow>
              <i-col :md="12">
                <Divider orientation="left">收入明细</Divider>
                <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>月均转账收入
                      <InfoPopTip content="统计口径:所有收入中的转账类型,合计/账单月份"/>
                    </h3>
                    <h2>¥{{ homeStat.incoming.transfer.monthAvg }}元</h2>
                    <span>笔均:¥{{ homeStat.incoming.transfer.billAvg }}元</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>月均工资
                      <InfoPopTip content="交易备注包括工资以及相关字段,合计工资除以累计的月份,不保证连续性"/>
                    </h3>
                    <h2>¥{{ homeStat.incoming.wages.monthAvg }}元</h2>
                    <span>累计月份:{{ homeStat.incoming.wages.countData }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>月均收单
                      <InfoPopTip content="交易备注包括收单以及相关字段,合计收单除以累计的月份,不保证连续性"/>
                    </h3>
                    <h2>¥{{ homeStat.incoming.posTrade.monthAvg }}元</h2>
                    <span>累计月份:{{ homeStat.incoming.posTrade.countData }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>其他收入
                      <InfoPopTip content="剔除转账/工资/收单的其他收入月均"/>
                    </h3>
                    <h2>¥{{ homeStat.incoming.other.monthAvg }}元</h2>
                  </i-col>
                </Row>
                <Divider orientation="left">支出明细</Divider>
                <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;">
                    <h3>月均转账支出
                      <InfoPopTip content="统计口径:所有支出中的转账类型,合计/账单月份"/>
                    </h3>
                    <h2>￥{{ homeStat.payout.transfer.monthAvg }}元</h2>
                    <span>笔均:¥{{ homeStat.payout.transfer.billAvg }}元</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.other">
                    <h3>月均日常消费
                      <InfoPopTip content="统计口径:消费中剔除其他主要支出后的所有支出"/>
                    </h3>
                    <h2>￥{{ homeStat.payout.other.monthAvg }}元</h2>
                    <span>笔均:{{ homeStat.payout.other.dayAvg }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.buy">
                    <h3>月均购物消费
                      <InfoPopTip content="统计口径:消费中电商/超市等购物相关信息的所有支出"/>
                    </h3>
                    <h2>¥{{ homeStat.payout.buy.monthAvg }}元</h2>
                    <span>笔均:{{ homeStat.payout.buy.dayAvg }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.car">
                    <h3>月均出行消费
                      <InfoPopTip content="统计口径:消费中旅行/飞机/酒店/滴滴等出行相关信息的所有支出"/>
                    </h3>
                    <h2>¥{{ homeStat.payout.car.monthAvg }}元</h2>
                    <span>笔均:{{ homeStat.payout.car.dayAvg }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.phone">
                    <h3>月均话费支出
                      <InfoPopTip content="统计口径:消费中话费相关信息的所有支出"/>
                    </h3>
                    <h2>¥{{ homeStat.payout.phone.monthAvg }}元</h2>
                    <span>笔均:{{ homeStat.payout.phone.dayAvg }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.sdm">
                    <h3>月均水电煤支出
                      <InfoPopTip content="统计口径:消费中水费/电费/煤气费/暖气费相关信息的所有支出"/>
                    </h3>
                    <h2>¥{{ homeStat.payout.sdm.monthAvg }}元</h2>
                    <span>笔均:{{ homeStat.payout.sdm.dayAvg }}</span>
                  </i-col>
                </Row>
                <Divider orientation="left">特殊交易数据</Divider>
                <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.luxury">
                    <h3>高端消费总额
                      <InfoPopTip content="统计口径:消费中黄金/珠宝/机票/奢侈品/高端酒店等相关信息的所有支出且金额大于1000"/>
                    </h3>
                    <h2>¥{{ homeStat.payout.luxury.money }}元</h2>
                    <span>消费次数:{{ homeStat.payout.luxury.countData }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.payout.manageMoney">
                    <h3>理财数据
                      <InfoPopTip content="统计口径:理财关联相关信息的所有"/>
                    </h3>
                    <h2>¥{{ homeStat.payout.manageMoney.money }}元</h2>
                    <span>交易次数:{{ homeStat.payout.manageMoney.countData }}</span>
                  </i-col>
                </Row>
                <Divider orientation="left">黑灰交易数据</Divider>
                <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.blackTrade.judicialFreeze">
                    <h3>司法冻结\解冻
                      <InfoPopTip content="交易备注含有司法冻结和司法解冻"/>
                    </h3>
                    <h2>¥{{ homeStat.blackTrade.judicialFreeze.money }}元
                      <Icon type="ios-alert" color="red" v-if="homeStat.blackTrade.judicialFreeze.money > 0"/>
                    </h2>
                    <span>冻结次数:{{ homeStat.blackTrade.judicialFreeze.countData }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.blackTrade.leisureEntertainment">
                    <h3>娱乐交易
                      <InfoPopTip
                        content="统计口径:消费中KTV/会所等相关信息的所有支出且金额大于500,辅助判断客户是否存在黄赌毒情况"/>
                    </h3>
                    <h2>¥{{ homeStat.blackTrade.leisureEntertainment.money }}元</h2>
                    <span>次数:{{
                        homeStat.blackTrade.leisureEntertainment.countData
                      }},笔均:{{ homeStat.blackTrade.leisureEntertainment.dayAvg }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.blackTrade.highFrequencyTransfer">
                    <h3>高频转账
                      <InfoPopTip content="统计口径:周期内转账超过五次的人数和天数,辅助判断客户是否存在关联交易和赌博情况"/>
                    </h3>
                    <h2>¥{{ homeStat.blackTrade.highFrequencyTransfer.money }}元</h2>
                    <span>人数:{{
                        homeStat.blackTrade.highFrequencyTransfer.monthAvg
                      }},天数:{{ homeStat.blackTrade.highFrequencyTransfer.dayAvg }}</span>
                  </i-col>
                  <i-col :md="6" style="height: 120px;padding-bottom: 10px;" v-if="homeStat.blackTrade.nightTradeList">
                    <h3>夜间交易
                      <InfoPopTip content="统计口径:晚上24点到早上5点之间交易的相关,辅助判断客户是否存在黄赌毒情况"/>
                    </h3>
                    <h2>¥{{ homeStat.blackTrade.nightTradeList.money }}元</h2>
                    <span>次数:{{
                        homeStat.blackTrade.nightTradeList.countData
                      }},天数:{{ homeStat.blackTrade.nightTradeList.dayAvg }}</span>
                  </i-col>
                </Row>
                <Row :gutter="20" shadow style="padding-left: 40px;padding-top: 20px">
                  <WordCloudMap style="height: 300px;width: 100%;" :value="stat.wordCloudData" ref="wordcloudmap"/>
                </Row>
              </i-col>
              <i-col :md="12" style="align-content: center">
                <Card shadow>
                  <SmoothLine style="height: 380px;" :value="stat.incomingList" text="收入月度走势" ref="incomingListLine"/>
                </Card>
                <Card shadow>
                  <SmoothLine style="height: 380px;" :value="stat.payoutList" text="支出月度走势" ref="payoutListLine"/>
                </Card>
                <Card shadow>
                  <chart-bar style="height: 380px;" :x="barData.x" :y="barData.y" text="24小时交易分布" ref="charbar"/>
                </Card>
              </i-col>
            </Row>
            <Row>
              <Col span="6">
                <chart-pie style="height: 250px;" :value="stat.tradePieData" text="交易占比" ref="tradePie"></chart-pie>
              </Col>
              <Col span="6">
                <chart-pie style="height: 250px;" :value="stat.payoutPieData" text="支出类型占比" ref="payoutPie"></chart-pie>
              </Col>
              <Col span="6">
                <chart-pie style="height: 250px;" :value="stat.incomingPieData" text="收入类型占比" ref="incomingPie"></chart-pie>
              </Col>
              <Col span="6">
                <chart-pie style="height: 250px;" :value="stat.consumeSubTypePieData" text="消费子类占比"
                          ref="consumeSubTypePie"></chart-pie>
              </Col>
            </Row>
            <Card shadow v-if="dataMap.bank_balance_list.length > 0">
              <SmoothLine style="height: 300px;" :value="stat.balanceList" text="银行卡余额走势图" ref="balanceListLine"/>
            </Card>
            <Card shadow v-if="dataMap.monthlySummaryList.length > 0">
              <ChartTableBar style="height: 300px;" :value="dataMap.monthlySummaryList" text="月度交易数据"
                            :series="monthlySummaryBar" ref="monthlySummaryBar"/>
            </Card>
          </div>
        </TabPane>
        <TabPane label="资产与收入" icon="logo-yen" name="zcysr">
          <div v-show="tabName === 'zcysr'">
            <Divider orientation="left">金额汇总数据<span v-if="dataMap.invalid_money">(剔除交易总金额：{{ Number(dataMap.invalid_money).toFixed(0) }})</span></Divider>
            <Table border highlight-row :columns="statBaseColumns" :data="dataMap.hz_sj"></Table>
            <Divider orientation="left" >日均余额数据</Divider>
            <Table border highlight-row :columns="dailyAvgColumns" :data="dataMap.bank_daily_avg_balance"></Table>
            <Divider orientation="left" v-if="dataMap.wages_info_summer">工资信息</Divider>
            <Table border highlight-row :columns="wagesInfoColumns" :data="dataMap.wages_info_summer"></Table>
            <Divider orientation="left" v-if="dataMap.pos_trade_summer">收单信息</Divider>
            <Table border highlight-row :columns="posTradeInfoColumns" :data="dataMap.pos_trade_summer"></Table>
            <Divider orientation="left" v-if="dataMap.yueebao_daily_avg_balance">余额宝数据</Divider>
            <Table border highlight-row :columns="yuebaoColumns" :data="dataMap.yueebao_daily_avg_balance"></Table>
            <Divider orientation="left" v-if="dataMap.manage_money_trade_summer">理财数据</Divider>
            <Table border highlight-row :columns="manageMoneyColumns" :data="dataMap.manage_money_trade_summer"></Table>
            <Divider orientation="left">小额交易汇总数据（五千以下）</Divider>
            <Table border highlight-row :columns="statBaseColumns" :data="dataMap.hz_sj_wq_yx"></Table>
          </div>
        </TabPane>
        <TabPane label="分渠道收支汇总" icon="ios-clipboard" name="fqdszhz">
          <div v-show="tabName === 'fqdszhz'">
            <Divider orientation="left" v-if="dataMap.bill_stat_weixin">微信汇总数据</Divider>
            <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_weixin" v-if="dataMap.bill_stat_weixin"></Table>
            <Divider orientation="left" v-if="dataMap.bill_stat_zhifubao">支付宝汇总数据</Divider>
            <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_zhifubao" v-if="dataMap.bill_stat_zhifubao"></Table>
            <Divider orientation="left" v-if="dataMap.bill_stat_bank">银行汇总数据</Divider>
            <Table border highlight-row :columns="statBaseColumns" :data="dataMap.bill_stat_bank" v-if="dataMap.bill_stat_bank"></Table>
            <div v-if="dataMap.sixMonthlySummaryList && dataMap.sixMonthlySummaryList.length > 0">
            <Divider orientation="left">近六个月交易数据</Divider>
            <Table border highlight-row :columns="monthlySummaryColumns" :data="dataMap.sixMonthlySummaryList"></Table>
            </div>
            <Divider orientation="left">月度交易数据</Divider>
            <Table border highlight-row :columns="monthlySummaryColumns" :data="dataMap.monthlySummaryList"></Table>
          </div>
        </TabPane>
        <TabPane label="负面相关交易数据" icon="ios-sad" name="fmxgjysj">
          <div v-show="tabName === 'fmxgjysj'">
            <Divider orientation="left">司法相关交易</Divider>
            <Table border highlight-row :columns="tradeInfoColumns" :data="dataMap.judicial_trade_list"></Table>
            <Divider orientation="left">异常交易</Divider>
            <Table border highlight-row :columns="tradeInfoColumns" :data="dataMap.error_flow_list"></Table>
            <Divider orientation="left">高频转账交易</Divider>
            <Table border highlight-row :columns="highFrequencyTradeInfoColumns" :data="dataMap.high_frequency_transfer_list"></Table>
            <Divider orientation="left">夜间交易</Divider>
            <Table border highlight-row :columns="transferBaseColumns" :data="dataMap.night_trade_list"></Table>
            <Divider orientation="left">娱乐相关交易</Divider>
            <Table border highlight-row :columns="tradeInfoColumns" :data="dataMap.leisure_entertainment_list"></Table>
            <Divider orientation="left">典当相关交易</Divider>
            <Table border highlight-row :columns="tradeInfoColumns" :data="dataMap.pawn_trading_list"></Table>
            <Divider orientation="left">抵押相关交易</Divider>
            <Table border highlight-row :columns="mortgageListColumns" :data="dataMap.mortgage_list"></Table>
            <Divider orientation="left">平入平出交易</Divider>
            <Table border highlight-row :columns="errorFlowTradeInfoColumns" :data="dataMap.error_flow_data_list"></Table>
            </div>
        </TabPane>
        <TabPane label="消费信贷汇总" icon="ios-card" name="xfxdhz">
          <div v-show="tabName === 'xfxdhz'">
            <Divider orientation="left" v-if="dataMap.credit_card_summary">卡交易数据</Divider>
            <Table border highlight-row :columns="cardBaseColumns" :data="dataMap.credit_card_summary"></Table>
            <Divider orientation="left" v-if="dataMap.repayment_summary">还款数据</Divider>
            <Table border highlight-row :columns="cardBaseColumns" :data="dataMap.repayment_summary"></Table>
          </div>
        </TabPane>
        <TabPane label="生活类交易数据汇总" icon="ios-basket" name="shljysjhz">
          <div v-show="tabName === 'shljysjhz'">
            <Divider orientation="left" v-if="dataMap.online_shopping_summary">电商消费数据</Divider>
            <Table border highlight-row :columns="onlineShoppingColumns" :data="dataMap.online_shopping_summary"></Table>
            <Divider orientation="left" v-if="dataMap.phone_monthly_summary">话费支出</Divider>
            <Table border highlight-row :columns="lifeColumns" :data="dataMap.phone_monthly_summary"></Table>
            <Divider orientation="left" v-if="dataMap.sdm_monthly_summary">水电煤支出</Divider>
            <Table border highlight-row :columns="lifeColumns" :data="dataMap.sdm_monthly_summary"></Table>
            <Divider orientation="left" v-if="dataMap.car_monthly_summary">汽车相关支出（包括：加油、停车）</Divider>
            <Table border highlight-row :columns="lifeColumns" :data="dataMap.car_monthly_summary"></Table>
            <Divider orientation="left" v-if="dataMap.travel_monthly_summary">出行旅游相关支出（包括：火车、飞机、酒店）</Divider>
            <Table border highlight-row :columns="lifeColumns" :data="dataMap.travel_monthly_summary"></Table>
          </div>
        </TabPane>
        <TabPane label="转账与消费数据汇总" icon="md-swap" name="zzyxfsjhz">
          <div v-show="tabName === 'zzyxfsjhz'">
            <Divider orientation="left">自我转账交易</Divider>
            <Table border highlight-row :columns="transferBaseColumns" :data="dataMap.self_transfer_summary"></Table>
            <Divider orientation="left">主要转账交易金额对手</Divider>
            <Table border highlight-row :columns="transferBaseColumns" :data="dataMap.transfer_counterparty_summary"></Table>
            <Divider orientation="left">主要转账交易次数对手</Divider>
            <Table border highlight-row :columns="transferBaseColumns" :data="dataMap.transfer_counterparty_count_summary"></Table>
            <Divider orientation="left">转账月度汇总</Divider>
            <Table border highlight-row :columns="monthlySummaryColumns" :data="dataMap.transfer_monthly_summary"></Table>
            <Divider orientation="left">主要消费对手交易</Divider>
            <Table border highlight-row :columns="payBaseColumns" :data="dataMap.pay_counterparty_count_summary"></Table>
            <Divider orientation="left">主要大额消费详情</Divider>
            <Table border highlight-row :columns="payDetailColumns" :data="dataMap.pay_counterparty_max_detail"></Table>
          </div>
        </TabPane>
    </Tabs>

  </div>
</template>
<script>
import ContentDataReport from './content-data-report.vue'
import { ChartBar, ChartPie, ChartTableBar, ProgressRing, SmoothLine, WordCloudMap } from '_c/charts'
import { InfoPopTip, InforCard } from '_c/info-card'
import CountTo from '_c/count-to'

export default {
  name: 'content-detail',
  props: {
    dataMap: {
      type: Object
    },
    score: Object,
    barData: Object,
    stat: Object,
    homeStat: Object
  },
  components: {
    ContentDataReport,
    ChartTableBar,
    ProgressRing,
    InforCard,
    ChartBar,
    CountTo,
    WordCloudMap,
    InfoPopTip,
    SmoothLine,
    ChartPie
  },
  data () {
    return {
      tabName: 'hzms',
      colSpan: 12,
      monthlySummaryBar: {
        x: 'statDesc',
        y: [{
          name: '收入',
          key: 'income'
        }, {
          name: '支出',
          key: 'payout'
        }, {
          name: '其他',
          key: 'other'
        }]
      },
      payDetailColumns: [{
        key: 'flowCard',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'logo-usd'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '付款方式')
          ])
        }
      }, {
        key: 'counterparty',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-person'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'logo-yen'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '金额')
          ])
        }
      }, {
        key: 'goodsDesc',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'md-information-circle'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '商品说明')
          ])
        }
      }],
      payBaseColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-people'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易对手')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],

      statBaseColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-paper'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '账单交易类型')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '笔数')
            ])
          }
        }, {
        //   key: 'yearAvg',
        //   className: 'table-header-cell',
        //   renderHeader: (h, params) => {
        //     return h('div', [
        //       h('Icon', {
        //         props: {
        //           type: 'md-analytics'
        //         },
        //         style: {
        //           marginRight: '5px'
        //         }
        //       }),
        //       h('strong', '年均')
        //     ])
        //   }
        // }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-analytics'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      monthlySummaryColumns:
        [{
          key: 'statDesc',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月份')
            ])
          }
        }, {
          key: 'income',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-trending-up'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '收入')
            ])
          }
        }, {
          key: 'payout',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-trending-down'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '支出')
            ])
          }
        }, {
          key: 'other',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('tooltip', {
              props: {
                transfer: true,
                placement: 'top',
                'max-width': '240'
              }
            },
            [
              h('span', [
                h('Icon', {
                  props: {
                    type: 'ios-cash-outline'
                  },
                  style: {
                    marginRight: '5px'
                  }
                }),
                h('span', '其他'),
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    color: '#c8c8c8'
                  }
                })
              ]),
              h('div',
                { slot: 'content' },
                [h('p', '剔除转账/工资/收单的其他收入')]
              )
            ])
          }
        }, {
          key: 'notRecording',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('tooltip', {
              props: {
                transfer: true,
                placement: 'top',
                'max-width': '240'
              }
            },
            [
              h('span', [
                h('Icon', {
                  props: {
                    type: 'ios-cash-outline'
                  },
                  style: {
                    marginRight: '5px'
                  }
                }),
                h('span', '不计收入'),
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    color: '#c8c8c8'
                  }
                })
              ]),
              h('div',
                { slot: 'content' },
                [h('p', '包含：活期转定期和定期转活期')]
              )
            ])
          }
        }],
      cardBaseColumns:
        [{
          key: 'cardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '银行/账户')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '金额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '笔数')
            ])
          }
        }, {
        //   key: 'yearAvg',
        //   className: 'table-header-cell',
        //   renderHeader: (h, params) => {
        //     return h('div', [
        //       h('Icon', {
        //         props: {
        //           type: 'md-analytics'
        //         },
        //         style: {
        //           marginRight: '5px'
        //         }
        //       }),
        //       h('strong', '年均')
        //     ])
        //   }
        // }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-analytics'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      dailyAvgColumns:
        [{
          key: 'cardNo',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-card'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '银行卡')
            ])
          }
        // }, {
        //   key: 'startTime',
        //   className: 'table-header-cell',
        //   renderHeader: (h, params) => {
        //     return h('div', [
        //       h('Icon', {
        //         props: {
        //           type: 'md-calendar'
        //         },
        //         style: {
        //           marginRight: '5px'
        //         }
        //       }),
        //       h('strong', '统计开始日期')
        //     ])
        //   }
        // }, {
        //   key: 'endTime',
        //   className: 'table-header-cell',
        //   renderHeader: (h, params) => {
        //     return h('div', [
        //       h('Icon', {
        //         props: {
        //           type: 'md-calendar'
        //         },
        //         style: {
        //           marginRight: '5px'
        //         }
        //       }),
        //       h('strong', '统计结束日期')
        //     ])
        //   }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-analytics'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '日均')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '近' + params.row.countData + '天')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '活跃天数')
            ])
          }
        }, {
          title: '排名',
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      yuebaoColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-paper'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易类型')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '日均金额')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-clipboard'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '日均生息')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '持有天数')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      manageMoneyColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-paper'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '理财类型')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-back'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '买入金额')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-forward'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '卖出金额')
            ])
          }
        }],
      lifeColumns:
        [{
          key: 'statTime',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易月份')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      onlineShoppingColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-apple'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '品牌')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-basket'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '件均消费')
            ])
          }
        }, {
          title: '月均消费',
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-cart'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均消费')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      transferBaseColumns:
        [{
          key: 'businessType',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-people'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易对手')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '交易次数')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-trending-up'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '收入')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-trending-down'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '支出')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      wagesInfoColumns:
        [{
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '工资总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-podium'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '发放次数')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'logo-yen'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均工资')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-thumbs-up'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '最高')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-thumbs-up-outline'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '最低')
            ])
          }
        }, {
          title: '排名',
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      posTradeInfoColumns:
        [{
          key: 'money',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-cash'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '收单总额')
            ])
          }
        }, {
          key: 'countData',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-calendar'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '累计月份')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-undo'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '月均收款')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-thumbs-up'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '最高')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell',
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-thumbs-up-outline'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '最低')
            ])
          }
        }, {
          key: 'rankData',
          className: 'table-header-cell',
          render: (h, params) => {
            return h('div', [
              h('strong', '前' + params.row.rankData + '%')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'md-stats'
                },
                style: {
                  marginRight: '5px'
                }
              }),
              h('strong', '排名')
            ])
          }
        }],
      tradeInfoColumns: [{
        key: 'counterparty',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-people'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'flowTime',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-calendar'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易时间')
          ])
        }
      }, {
        key: 'flowType',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-analytics'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易类型')
          ])
        }
      }, {
        key: 'flowDirection',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-thumbs-up'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易方向')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-cash'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易金额')
          ])
        }
      }, {
        key: 'balance',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'logo-yen'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '金额')
          ])
        }
      }],
      mortgageListColumns: [{
        key: 'counterparty',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-people'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'flowTime',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-calendar'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易时间')
          ])
        }
      }, {
        key: 'flowType',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-analytics'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易类型')
          ])
        }
      }, {
        key: 'flowDirection',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-thumbs-up'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易方向')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-cash'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易金额')
          ])
        }
      }, {
        key: 'balance',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'logo-yen'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '金额')
          ])
        }
      }, {
        key: 'goodsDesc',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'logo-yen'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易详细')
          ])
        }
      }],
      highFrequencyTradeInfoColumns: [{
        key: 'counterparty',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-people'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'flowTime',
        className: 'table-header-cell',
        render: (h, params) => {
          return h('div', [
            h('span', params.row.flowTime.slice(0, 10))
          ])
        },
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-calendar'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易时间')
          ])
        }
      }, {
        key: 'flowType',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-podium'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易次数')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-cash'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易金额')
          ])
        }
      }],
      errorFlowTradeInfoColumns: [{
        key: 'counterparty',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-people'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易对手')
          ])
        }
      }, {
        key: 'money',
        className: 'table-header-cell',
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-cash'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '交易金额')
          ])
        }
      }, {
        key: 'flowTime',
        className: 'table-header-cell',
        render: (h, params) => {
          return h('div', [
            h('span', params.row.flowTime.slice(0, 10))
          ])
        },
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-calendar'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '收入交易时间')
          ])
        }
      }, {
        key: 'flowCard',
        className: 'table-header-cell',
        render: (h, params) => {
          return h('div', [
            h('span', params.row.flowCard.slice(0, 10))
          ])
        },
        renderHeader: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'ios-calendar'
              },
              style: {
                marginRight: '5px'
              }
            }),
            h('strong', '支出交易时间')
          ])
        }
      }]
    }
  },
  mounted: function () {
    this.setData(this.$parent.dataMap, this.$parent.homeStat, this.$parent.score, this.$parent.barData, this.$parent.stat)
  },
  methods: {
    setData (dataMap, homeStat, score, barData, stat) {
      if (Number(homeStat.statMonth) < 12) {
        if (typeof dataMap.hz_sj !== 'undefined') {
          dataMap.hz_sj.forEach(element => {
            element.yearAvg = '-'
          })
          dataMap.hz_sj_sumData.yearAvg = '-'
        }
        if (typeof dataMap.hz_sj_wq_yx !== 'undefined') {
          dataMap.hz_sj_wq_yx.forEach(element => {
            element.yearAvg = '-'
          })
        }
        if (typeof dataMap.bill_stat_weixin !== 'undefined') {
          dataMap.bill_stat_weixin.forEach(element => {
            element.yearAvg = '-'
          })
          dataMap.bill_stat_sumData.yearAvg = '-'
        }
        if (typeof dataMap.bill_stat_zhifubao !== 'undefined') {
          dataMap.bill_stat_zhifubao.forEach(element => {
            element.yearAvg = '-'
          })
        }
        if (typeof dataMap.bill_stat_bank !== 'undefined') {
          dataMap.bill_stat_bank.forEach(element => {
            element.yearAvg = '-'
          })
        }
        if (typeof dataMap.credit_card_summary !== 'undefined') {
          dataMap.credit_card_summary.forEach(element => {
            element.yearAvg = '-'
          })
        }
        if (typeof dataMap.repayment_summary !== 'undefined') {
          dataMap.repayment_summary.forEach(element => {
            element.yearAvg = '-'
          })
        }
      }
      this.dataMap = this.getDataMap()
      this.dataMap = dataMap
      this.score = score
      this.barData = barData
      this.stat = stat
      this.homeStat = homeStat
    },
    getDataMap () {
      return {
        uploadLog: [],
        hz_sj: [],
        hz_sj_yw_yx: [],
        hz_sj_wq_yx: [],
        bill_stat_weixin: [],
        bill_stat_zhifubao: [],
        bill_stat_bank: [],
        monthlySummaryList: [],
        credit_card_summary: [],
        repayment_summary: [],
        yueebao_daily_avg_balance: [],
        manage_money_trade_summer: [],
        phone_monthly_summary: [],
        sdm_monthly_summary: [],
        car_monthly_summary: [],
        travel_monthly_summary: [],
        transfer_monthly_summary: [],
        transfer_counterparty_summary: [],
        transfer_counterparty_count_summary: [],
        transfer_counterparty_night_count_summary: [],
        judicial_trade_list: [],
        error_flow_list: [],
        leisure_entertainment_list: [],
        pay_counterparty_count_summary: [],
        pay_counterparty_max_detail: [],
        bank_daily_avg_balance: [],
        wages_info_summer: [],
        pos_trade_summer: [],
        online_shopping_summary: [],
        bank_balance_list: [],
        high_frequency_transfer_list: [],
        night_trade_list: []
      }
    }
  }
}
</script>
<style>
.content-detail {
  margin-top: 53pt;
}
.dvd-font {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 18pt;
    color: #666666;
}
.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
  background: #1242CD;
  color:white;
}
.ivu-tabs-nav-container{
  font-size: 18px;
  font-weight: bold;
}
.ivu-tabs-tab {
  background: white;
  color:#1242CD;
}
.hz-row {
  text-align:center;
  font-weight: bold;
  color:#1242CD
}
.count-num {
  font-size: 30pt;
}
.count-title {
  font-size:14pt;
  color:#A1A1A1;
}
</style>
